import { render, staticRenderFns } from "./TitledDogs.vue?vue&type=template&id=2a94f376"
import script from "./TitledDogs.vue?vue&type=script&lang=ts"
export * from "./TitledDogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports